/* Mobile menu */
document.querySelectorAll('[data-nav-toggle]').forEach(function(b){b.addEventListener('click',function(){document.body.classList.toggle('nav-open');});});
document.querySelectorAll('.mobile-menu a').forEach(function(a){a.addEventListener('click',function(){document.body.classList.remove('nav-open');});});

/* Graceful image fallback -> branded plum panel */
function bindFallback(imgSel, parentSel){
  document.querySelectorAll(imgSel).forEach(function(img){
    function fb(){var p=img.closest(parentSel); if(p)p.classList.add('no-img');}
    img.addEventListener('error', fb);
    if(img.complete && img.naturalWidth===0) fb();
  });
}
bindFallback('.stack-media img','.stack');
bindFallback('.prod-media img','.prod');
bindFallback('.g-media img','.g-item');

/* Note: the contact form on the Contact page now posts to Shopify's built-in
   contact form handler ({% form 'contact' %}) instead of opening a mailto
   link. Messages arrive in the store's Customer contact form notification
   email, configurable in Shopify admin under Settings > Notifications. */

/* ===== Quantity steppers (product page + cart) ===== */
document.addEventListener('click', function(e){
  var dec = e.target.closest('[data-qty-decrease]');
  var inc = e.target.closest('[data-qty-increase]');
  if(!dec && !inc) return;
  var wrap = e.target.closest('.qty-stepper');
  var input = wrap && wrap.querySelector('input[type="number"]');
  if(!input) return;
  var min = parseInt(input.min || '0', 10);
  var val = parseInt(input.value || '1', 10);
  if(inc) val += 1;
  if(dec) val = Math.max(min, val - 1);
  input.value = val;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ===== Variant option pills -> sync hidden <select name="id"> ===== */
document.querySelectorAll('.product-form').forEach(function(form){
  var select = form.querySelector('[data-variant-select]');
  if(!select) return;
  var groups = form.querySelectorAll('.product-option');
  function currentSelections(){
    return Array.from(groups).map(function(g){
      var sel = g.querySelector('.opt-pill.is-selected');
      return sel ? sel.dataset.optionValue : null;
    });
  }
  function syncVariant(){
    var chosen = currentSelections();
    var options = Array.from(select.options);
    var match = options.find(function(o){
      var parts = o.textContent.trim().split(' - Sold out')[0].split(' / ');
      return chosen.every(function(v, i){ return v === null || parts[i] === v; });
    });
    if(match){
      select.value = match.value;
      var submitBtn = form.querySelector('button[type="submit"]');
      if(submitBtn){
        submitBtn.disabled = match.disabled;
        submitBtn.textContent = match.disabled ? 'Sold Out' : 'Add to Cart';
      }
    }
  }
  groups.forEach(function(g){
    g.querySelectorAll('.opt-pill').forEach(function(pill){
      pill.addEventListener('click', function(){
        g.querySelectorAll('.opt-pill').forEach(function(p){ p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        syncVariant();
      });
    });
  });
});

/* ===== Product page thumbnail swap ===== */
document.querySelectorAll('.product-thumb').forEach(function(thumb){
  thumb.addEventListener('click', function(){
    var mainImg = document.querySelector('[data-main-image] img');
    if(mainImg) mainImg.src = thumb.dataset.mediaSrc;
  });
});

/* ===== Cart page: quantity change resubmits the cart form ===== */
document.querySelectorAll('[data-cart-qty]').forEach(function(input){
  input.addEventListener('change', function(){
    var form = input.closest('.cart-form');
    if(form) form.submit();
  });
});

/* ===== Toast ===== */
var toastTimer;
function showToast(msg){
  var el = document.querySelector('[data-toast]');
  if(!el) return;
  el.innerHTML = msg;
  el.classList.add('is-visible');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(function(){ el.classList.remove('is-visible'); }, 3200);
}

/* ===== Cart drawer: open/close ===== */
function openCartDrawer(){ document.body.classList.add('cart-open'); refreshCartDrawer(); }
function closeCartDrawer(){ document.body.classList.remove('cart-open'); }
document.querySelectorAll('[data-cart-drawer-open]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openCartDrawer(); }); });
document.querySelectorAll('[data-cart-drawer-close]').forEach(function(b){ b.addEventListener('click', closeCartDrawer); });
document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCartDrawer(); });

function escapeHtml(str){
  return (str || '').replace(/[&<>"']/g, function(c){
    return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
  });
}

function moneyFormat(cents){
  return '$' + (cents / 100).toFixed(2);
}

function renderCartDrawer(cart){
  var body = document.querySelector('[data-cart-drawer-body]');
  var foot = document.querySelector('[data-cart-drawer-foot]');
  var countEl = document.querySelector('[data-cart-drawer-count]');
  var subtotalEl = document.querySelector('[data-cart-drawer-subtotal]');
  var navCount = document.querySelector('[data-cart-count]');
  if(!body) return;

  if(navCount) navCount.textContent = cart.item_count;
  if(countEl) countEl.textContent = cart.item_count > 0 ? ' (' + cart.item_count + ')' : '';
  if(subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);
  if(foot) foot.style.display = cart.item_count > 0 ? '' : 'none';

  if(cart.item_count === 0){
    body.innerHTML = '<div class="cart-drawer-empty"><p>Your bag is empty.</p><a href="/pages/shop" class="btn btn-solid" data-cart-drawer-close>Shop the Collections</a></div>';
    body.querySelector('[data-cart-drawer-close]').addEventListener('click', closeCartDrawer);
    return;
  }

  body.innerHTML = cart.items.map(function(item){
    var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-drawer-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    var personalization = (item.properties && item.properties.Personalization)
      ? '<div class="cart-drawer-item-variant">Personalization: ' + escapeHtml(item.properties.Personalization) + '</div>' : '';
    return (
      '<div class="cart-drawer-item" data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '">' + (item.image ? '<img src="' + item.image + '&width=160" alt="' + escapeHtml(item.product_title) + '">' : '<img src="" alt="">') + '</a>' +
        '<div class="cart-drawer-item-info">' +
          '<a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          variantLine + personalization +
          '<div class="cart-drawer-item-foot">' +
            '<div class="qty-stepper">' +
              '<button type="button" data-qty-decrease aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" min="0" value="' + item.quantity + '" data-cart-drawer-qty data-line-key="' + item.key + '">' +
              '<button type="button" data-qty-increase aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="cart-drawer-item-price">' + moneyFormat(item.final_line_price) + '</span>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-drawer-remove" data-cart-drawer-remove data-line-key="' + item.key + '">Remove</button>' +
      '</div>'
    );
  }).join('');
}

function refreshCartDrawer(){
  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(function(r){ return r.json(); })
    .then(renderCartDrawer)
    .catch(function(){});
}

function changeCartLine(key, quantity){
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function(r){ return r.json(); }).then(renderCartDrawer);
}

/* Cart drawer: qty stepper input change (reuses the global data-qty-decrease/increase click handler above) */
document.addEventListener('change', function(e){
  var input = e.target.closest('[data-cart-drawer-qty]');
  if(!input) return;
  var qty = Math.max(0, parseInt(input.value || '0', 10));
  changeCartLine(input.dataset.lineKey, qty);
});

/* Cart drawer: remove item */
document.addEventListener('click', function(e){
  var btn = e.target.closest('[data-cart-drawer-remove]');
  if(!btn) return;
  changeCartLine(btn.dataset.lineKey, 0);
});

/* ===== AJAX add-to-cart on the product form ===== */
document.querySelectorAll('.product-form').forEach(function(form){
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
    .then(function(r){ return r.json().then(function(data){ return { ok: r.ok, data: data }; }); })
    .then(function(res){
      if(!res.ok){
        showToast(res.data.description || 'Couldn\'t add that to your bag.');
        return;
      }
      showToast('<b>Added to bag</b> — ' + escapeHtml(res.data.product_title || res.data.title));
      openCartDrawer();
    })
    .catch(function(){ showToast('Something went wrong — please try again.'); })
    .finally(function(){
      if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
    });
  });
});

/* ===== Product info tabs (accordion) ===== */
document.querySelectorAll('.p-tab.is-open .p-tab-panel').forEach(function(panel){
  panel.style.maxHeight = panel.scrollHeight + 'px';
});
document.querySelectorAll('.p-tab-btn').forEach(function(btn){
  btn.addEventListener('click', function(){
    var tab = btn.closest('.p-tab');
    var panel = tab.querySelector('.p-tab-panel');
    var isOpen = tab.classList.contains('is-open');
    tab.parentElement.querySelectorAll('.p-tab').forEach(function(t){
      t.classList.remove('is-open');
      t.querySelector('.p-tab-panel').style.maxHeight = null;
    });
    if(!isOpen){
      tab.classList.add('is-open');
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }
  });
});

/* ===== Product image zoom ===== */
document.querySelectorAll('[data-zoomable]').forEach(function(el){
  el.addEventListener('click', function(){
    var img = el.querySelector('img');
    var overlay = document.querySelector('[data-zoom-overlay]');
    if(!img || !overlay || !img.src) return;
    overlay.querySelector('img').src = img.src;
    overlay.classList.add('is-visible');
  });
});
document.querySelectorAll('[data-zoom-close]').forEach(function(b){
  b.addEventListener('click', function(){
    document.querySelector('[data-zoom-overlay]').classList.remove('is-visible');
  });
});

/* ===== Collection sort ===== */
document.querySelectorAll('[data-sort-select]').forEach(function(sel){
  sel.addEventListener('change', function(){
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    window.location.href = url.toString();
  });
});
